module.exports = __webpack_public_path__ + "img/edge_hebergements_camping.0ec47585.svg";